import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  static values = {
    containerId: { type: String, default: "invoiceable-select-container" },
    memberSelectId: { type: String, default: "" }
  }

  connect() {
    if (this.resolveSelect()) {
      this.updateSelect()
    }
  }

  resolveSelect() {
    if (this.memberSelectIdValue) {
      return document.getElementById(this.memberSelectIdValue)
    }

    const container = document.getElementById(this.containerIdValue)
    return container?.querySelector("select") || document.getElementById("invoiceable_search")
  }

  updateSelect(event) {
    const type = this.element.value
    const select = this.resolveSelect()

    if (!select) return

    const tomSelectController = this.application.getControllerForElementAndIdentifier(
      select,
      "tom-select"
    )

    if (!type) {
      select.disabled = true
      if (tomSelectController) {
        tomSelectController.loadUrlValue = ""
        tomSelectController.clear()
        tomSelectController.clearOptions()
        tomSelectController.disable()
      }
      return
    }

    select.disabled = false

    // Fetch the appropriate records based on type
    const url = type === "Contact" ? "/contacts.json" : "/companies.json"

    if (tomSelectController) {
      tomSelectController.enable()
      tomSelectController.clear()
      tomSelectController.clearOptions()
      tomSelectController.loadUrlValue = url
      return
    }

    // Fallback for non-Tom Select usage
    select.innerHTML = '<option value="">Select invoiceable</option>'
    fetch(url)
      .then(response => response.json())
      .then(data => {
        data.forEach(item => {
          const option = document.createElement("option")
          option.value = item.id
          const displayName = item.name || `${item.firstname || ""} ${item.lastname || ""}`.trim() || "Unnamed"
          option.textContent = displayName
          select.appendChild(option)
        })
      })
      .catch(error => {
        console.error("Error fetching invoiceables:", error)
      })
  }
}
